import CompanyOvertimeViewComponent from "../components/CompanyOvertimeView";
import useCompanyOvertime from "../hooks/useCompanyOvertime";

const CompanyOvertimeView = (props) => {
  const useCompanyOvertimeProps = useCompanyOvertime(props);
  return <CompanyOvertimeViewComponent {...useCompanyOvertimeProps} />;
};

export default CompanyOvertimeView;
